module.exports = "/img/car-recommend-img.80e9741a.png";